export default "__VITE_ASSET__6ff9ba8e__"